export default "__VITE_PUBLIC_ASSET__6a46a1e2__"